import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { HostListener } from '@angular/core';
import { AuthService } from './services/auth.service';
import { AppModule } from './app.module';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [AppModule, RouterOutlet, CommonModule]
})
export class AppComponent {
  constructor(private titleService: Title, private authService: AuthService) {
    this.titleService.setTitle(environment.browserTabTitel);
  }

  // man kann leider das display nicht ändern und man kann nicht zwischen reload und closing tab unterscheiden 
  @HostListener('window:beforeunload', ['$event']) beforeunloadHandler(event) {
    if (!this.authService.isLoggedIn()) {
      return true;
    }
    else {
      return false;
    }
  }
}
